export interface InitOutput {
    memory: { buffer: ArrayBuffer };
    [key: string]: any;
}
export default async function initLibfluxcore(args?: any): Promise<InitOutput> {
    return { memory: { buffer: new ArrayBuffer(0) } };
}
export function initSync(args?: any): any {
    return { memory: { buffer: new ArrayBuffer(0) } };
}
export function crop_rotate_rgba_into_buffer(...args: any[]): any {}
export function __resetLibfluxcoreWasmForMemoryPressure(): void {}
export function is_animated_image(...args: any[]): any { return false; }
export function sniff_image_format(...args: any[]): any { return 0; }
export function create_zstd_stream_decoder(...args: any[]): any { return 0; }
export function decompress_zstd_stream_chunk(...args: any[]): any { return new Uint8Array(0); }
export function free_zstd_stream_decoder(...args: any[]): any {}
export function create_zstd_stream_encoder(...args: any[]): any { return 0; }
export function compress_zstd_stream_chunk(...args: any[]): any { return new Uint8Array(0); }
export function free_zstd_stream_encoder(...args: any[]): any {}
